import { Record } from 'immutable';

type TypeRessource = {
  id: string;
  titre: string;
  description: string;
  resume: string;
  idImage: string;
  image: string | null;
  categorie: string;
  cheminFichier: string;
  estActif: boolean;
};

// Le modèle doit correspondre au DTO backend
const RessourceRecord = Record<TypeRessource>({
  id: '',
  titre: '',
  description: '',
  resume: '',
  idImage: '',
  image: null,
  categorie: '',
  cheminFichier: '',
  estActif: true,
});

class Ressource extends RessourceRecord {
  get id() { return this.get('id'); }
  get titre() { return this.get('titre'); }
  get description() { return this.get('description'); }
  get resume() { return this.get('resume'); }
  get idImage() { return this.get('idImage'); }
  get image() { return this.get('image'); }
  get categorie() { return this.get('categorie'); }
  get cheminFichier() { return this.get('cheminFichier'); }
  get estActif() { return this.get('estActif'); }

  constructor(props: Partial<TypeRessource> = {}) {
    super({
      ...props,
      titre: props.titre || '',
      description: props.description || '',
      resume: props.resume || '',
      idImage: props.idImage || '',
      image: props.image || null,
      categorie: props.categorie || '',
      cheminFichier: props.cheminFichier || '',
      estActif: props.estActif !== undefined ? props.estActif : true,
    });
  }

  setId(id: string) { return this.set('id', id); }
  setTitre(titre: string) { return this.set('titre', titre); }
  setDescription(description: string) { return this.set('description', description); }
  setResume(resume: string) { return this.set('resume', resume); }
  setIdImage(idImage: string) { return this.set('idImage', idImage); }
  setImage(image: string | null) { return this.set('image', image); }
  setCategorie(categorie: string) { return this.set('categorie', categorie); }
  setCheminFichier(cheminFichier: string) { return this.set('cheminFichier', cheminFichier); }
  setEstActif(estActif: boolean) { return this.set('estActif', estActif); }

  toDto() {
    return {
      Id: this.id,
      Titre: this.titre,
      Description: this.description,
      Resume: this.resume,
      IdImage: this.idImage,
      Categorie: this.categorie,
      CheminFichier: this.cheminFichier,
      EstActif: this.estActif,
    };
  }
}

export default Ressource;
